import React, {FC, useState} from 'react';
import {UseFormClearErrors, UseFormRegister, UseFormSetError, UseFormSetValue, UseFormWatch} from 'react-hook-form';
import {Teacher} from '../../shared/types/teacher';
import HLFormInput from '../../shared/components/input/HLFormInput';
import HLErrorMessage from '../../shared/components/error-message/HLErrorMessage';
import HLIconButton from '../../shared/components/icon-button/HLIconButton';
import CloseIcon from '../../shared/styles/icons/CloseIcon';
import PlusIcon from '../../shared/styles/icons/PlusIcon';
import TeacherSearchModal from '../../modal/teacher/TeacherSearchModal';
import classes from './Selector.module.scss';
import {AgreementTeacherStructure} from "../../shared/types/agreement";

interface TeacherSelectorProps {
    register: UseFormRegister<any>;
    setError: UseFormSetError<any>;
    clearErrors: UseFormClearErrors<any>;
    setValue: UseFormSetValue<any>;
    watch: UseFormWatch<any>;
    errors: any;
}

const TeacherSelector: FC<TeacherSelectorProps> = ({
    register,
    setError,
    clearErrors,
    setValue,
    watch,
    errors
}) => {
    const [isTeacherSearchOpen, setIsTeacherSearchOpen] = useState(false);

    register('selectedTeacher', {
        required: 'Учитель обязателен',
    });

    const selectedTeacher: AgreementTeacherStructure = watch('selectedTeacher');

    const openTeacherModal = () => setIsTeacherSearchOpen(true);

    const addTeacher = (teacher: Teacher) => {
        setValue('selectedTeacher', {...teacher});
        clearErrors('selectedTeacher');
        setIsTeacherSearchOpen(false);
    };

    const deleteTeacher = () => {
        setValue('selectedTeacher', null);
        setError('selectedTeacher', {type: 'required', message: 'Учитель обязателен'});
    };

    return (
        <>
            <div className="columnContainer">
                <div className="inlineContainer">
                    <h3>Учитель</h3>
                    <HLIconButton
                        type="button"
                        icon={<PlusIcon/>}
                        onClick={openTeacherModal}
                        aria-label="Добавить учителя"
                    />
                </div>

                {selectedTeacher && (
                    <div className="inlineContainer">
                        <div className={classes.dynamicInput}>
                            <HLFormInput
                                id="selectedTeacher"
                                value={`${selectedTeacher.firstName} ${selectedTeacher.lastName}`}
                                readOnly
                                placeholder="Учитель"
                            />
                        </div>

                        <div className={classes.dynamicInput}>
                            <HLFormInput
                                id="teacherRate"
                                type="number"
                                step="0.01"
                                min="0.01"
                                {...register('selectedTeacher.teacherRate', {
                                    required: 'Ставка учителя обязательна',
                                    valueAsNumber: true,
                                    min: {value: 0.01, message: 'Ставка должна быть больше 0'}
                                })}
                                placeholder="Ставка учителя"
                                error={errors.teacherRate?.message}
                            />
                        </div>

                        <div className={classes.dynamicButton}>
                            <HLIconButton
                                icon={<CloseIcon/>}
                                onClick={deleteTeacher}
                                aria-label="Удалить учителя"
                            />
                        </div>
                    </div>
                )}

                <HLErrorMessage
                    error={errors.selectedTeacher?.message}
                />
            </div>

            <TeacherSearchModal
                open={isTeacherSearchOpen}
                setOpen={setIsTeacherSearchOpen}
                onSelect={addTeacher}
            />
        </>
    );
};

export default TeacherSelector;